import http from "../http"

class BirthdayService {

    async getCalendar(data) {
        const rqst = await http.post('/birthdays/calendar/', data)
        return rqst.data
    }

    async getUpcoming(data) {
        const rqst = await http.post('/birthdays/upcoming/', data)
        return rqst.data
    }

    async search(data) {
        const rqst = await http.post('/birthdays/search/', data)
        return rqst.data
    }

    async getMissing(data) {
        const rqst = await http.post('/birthdays/missing/', data)
        return rqst.data
    }

    async notifyMissing(data) {
        const rqst = await http.post('/birthdays/notify-missing/', data)
        return rqst.data
    }

    async getLogs(data) {
        const rqst = await http.post('/birthdays/logs/', data)
        return rqst.data
    }

    async getWishes(employeeId, data) {
        const rqst = await http.post(`/birthdays/wish/${employeeId}/`, data)
        return rqst.data
    }

    async createWish(data) {
        const rqst = await http.post('/birthdays/wish/', data)
        return rqst.data
    }

    async sendGift(data) {
        const rqst = await http.post('/birthdays/send-gift/', data)
        return rqst.data
    }

    async getConfig(data) {
        const rqst = await http.post('/birthdays/config/', data)
        return rqst.data
    }

    async updateConfig(data) {
        const rqst = await http.put('/birthdays/config/', data)
        return rqst.data
    }

    exportIcsUrl(companyId) {
        const base = http.defaults.baseURL || ''
        return `${base}v1/birthdays/export.ics?company_id=${companyId}`
    }
}

const birthdayService = new BirthdayService()
export default birthdayService
